export default {
  small: "sm",
  medium: "md",
  large: "lg",
};
